import { render, staticRenderFns } from "./create-bulk.vue?vue&type=template&id=0ac814f8&scoped=true&"
import script from "./create-bulk.vue?vue&type=script&lang=js&"
export * from "./create-bulk.vue?vue&type=script&lang=js&"
import style0 from "./create-bulk.vue?vue&type=style&index=0&id=0ac814f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac814f8",
  null
  
)

export default component.exports